// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"B9-z"};